
import VectorSource from 'ol/source/Vector';

import DrawMeasure from './DrawMeasure';
import { styleFunction } from './measureStyle';
import { calculateMeasureValuesInGeometry } from './measureValues';

function createInteractionMeasurePoint(options) {

    const MAP_TOOL_ID = 'MeasurePoint';

    const handleMapToolExecute = (coords_, values_ = {}, action_ = 'measureupdated', geometry_ = null) => {
        if (options.onMapToolExecute) {
            options.onMapToolExecute(
                MAP_TOOL_ID,
                {
                    action: action_,
                    values: {
                        ...values_,
                        coords: coords_
                    },
                    geometry: geometry_
                }
            );
        }
    }

    const handlePointerMove = (event) => {
        handleMapToolExecute([{
            x: event.coordinate[0],
            y: event.coordinate[1],
            z: 0
        }]);
    }

    const handleDrawAbort = () => {
        // nop;
    }

    const handleDrawEnd = (e) => {
        let geometry = e.feature.getGeometry();

        const values = calculateMeasureValuesInGeometry(
            geometry,
            ['id', 'coords']
        );

        handleMapToolExecute(
            [{
                x: geometry.flatCoordinates[0],
                y: geometry.flatCoordinates[1],
                z: 0
            }],
            values,
            'measureend',
            geometry,
        );
    }

    let source = new VectorSource({});

    let draw = new DrawMeasure({
        source: source,
        type: 'Point',
        style: function (feature) {
            return styleFunction(feature, true, 'Point', null);
        },
        onPointerMove: function (event) {
            handlePointerMove(event);
        }
    });

    draw.on('drawabort', handleDrawAbort);
    draw.on('drawend', handleDrawEnd);

    draw.set('mapToolId', MAP_TOOL_ID);
    draw.setActive(false);

    return draw;
}

export default createInteractionMeasurePoint;
